import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {autobind} from 'core-decorators';
import classNames from 'classnames';
import {Select} from 'components/forms';
import styles from './styles.css';

@autobind
export default class SelectedProducts extends Component {
    static propTypes = {
        items: PropTypes.array.isRequired,
        onUpdate: PropTypes.func.isRequired,
        onRemove: PropTypes.func.isRequired,
        getQuantityOptions: PropTypes.func,
    };

    render() {
        return (
            <table className={classNames(styles.root, styles.selectedProductsTable)}>
                <thead className={styles.header}>
                    <tr>
                        <th>Categoría</th>
                        <th>Cartel</th>
                        <th>Cantidad</th>
                        <th />
                    </tr>
                </thead>
                <tbody className={styles.body}>
                    {this.props.items.map(item => (
                        <tr key={item.item}>
                            <td>
                                <span className={styles.mobileOnly}>Categoría: </span>
                                {item.category.name}
                            </td>
                            <td>
                                <span className={styles.mobileOnly}>Cartel: </span>
                                {item.name}
                            </td>
                            <td>
                                <span className={styles.mobileOnly}>Cantidad: </span>
                                <Select
                                    options={this.props.getQuantityOptions(item.item)}
                                    value={item.quantity}
                                    onChange={this.props.onUpdate(item.item)}
                                />
                            </td>
                            <td>
                                <button
                                    type='button'
                                    className={styles.delete}
                                    onClick={this.props.onRemove(item.item)}
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    }
}



// WEBPACK FOOTER //
// ./components/product-picker/selected-products/index.js